/**
 * Which PMS patient, if any, an invite is for — the one rule that decides what the link-back writes
 * into the vendor's record, and so the only place a wrong binding can originate: it maps a Grin patient
 * onto a PMS one, and nothing on our side can repair that write.
 *
 * Its own module rather than a function inside the hook, so it can be tested as the pure rule it is
 * without loading the hook's import chain.
 *
 * Both halves are required. A preset from any other entry point (the Dolphin "patients to invite" table
 * sends neither) comes back null, so the link-back never fires for it.
 *
 * `app` rides along when the preset has one: the vendor publishes us as two apps whose patient
 * mappings live in separate namespaces, so a link written as the wrong one returns 200 into a
 * namespace its launcher never reads. It is optional — a link built before the apps were told apart
 * carries none, and the service falls back to its default app, which is what those links meant.
 *
 * @param {{ pms?: string, pmsPatientId?: string, pmsApp?: string }} presetDetails the invite preset
 * @returns {{ pms: string, pmsPatientId: string, app?: string } | null}
 */
export const readPmsInviteLink = presetDetails =>
  presetDetails?.pms && presetDetails?.pmsPatientId
    ? {
        pms: presetDetails.pms,
        pmsPatientId: presetDetails.pmsPatientId,
        ...(presetDetails.pmsApp ? { app: presetDetails.pmsApp } : {})
      }
    : null
